import { ConfigParam } from '../api';

export interface ConfigModel {
  loaded: boolean;
  isMautrechner?: boolean;
  isRegistrierung?: boolean;
  isDisableUhrzeitfelder?: boolean;
  customServices?: string;
  isTauschgeraete?: boolean;
  auftragsresearchtableconfig?: string;
  isCustomstylebuttons?: boolean;
  clientKunde?: string;
  isLaengePflichtfeld: boolean;
  isBreitePflichtfeld: boolean;
  isHoehePflichtfeld: boolean;
  isVerkehrsartPflichtfeld: boolean;
  isLademeterBerechnen: boolean;
  isStellplaetzeBerechnen: boolean;
  isUserCanEditImmediately: boolean;
  isBexPremium: boolean;
  isPreisermittlung: boolean;
  isZusaetzlicheLademittel: boolean;
  isServicesInternSendungen: boolean;
  clientInfobox?: string;
  isAdresseTelefonEdit: boolean;
  isAdresseEinmaladresseEdit: boolean;
  isAdresseKontaktEdit: boolean;
  isAdresseUnsichtbarEdit: boolean;
  mandantSpezi29: boolean;
  dokumentenverweise: boolean;
  isBeladedatumVorbelegen: boolean;
  isEntladedatumVorbelegen: boolean;
  ttVersenderBlockLabel?: string;
  ttVersenderFremdnummerLabel?: string;
  ttVersenderMatchcode: boolean;
  ttVersenderFremdnummer: boolean;
  ttVersenderName: boolean;
  ttVersenderStrasse: boolean;
  ttVersenderOrt: boolean;
  ttEmpfaengerMatchcode: boolean;
  ttEmpfaengerFremdnummer: boolean;
  ttEmpfaengerStrasse: boolean;
  ttInhalt: boolean;
  isShowTTMailAdress: boolean;
  clientMinLengthPw?: string;
  isShowEmpfRechnung?: boolean;
  denyOrderEdit: boolean;
  isShowKlassifizierung?: boolean; //neuer config_param
  isNoADRVerpackungen?: boolean;
  isNoADRLademittel?: boolean;
  isDenyZustelldatum?: boolean;
  saveKontaktdaten?: boolean;
  terminArtFixTermin?: string;
  isAbsenderEditDeny?: boolean;
  isShowAbsenderNeutral?: boolean;
  isAbholDatumPflicht?: boolean;
  isZustellDatumPflicht?: boolean;
  isTTSwitchAbsenderToNeutral: boolean;
  defaultWaehrung?: string;
  directly_back_2list?: boolean;
  zustelldatum_offset: string;
  zustelldatum_off: boolean;
  isDeleteDocumentsForbidden: boolean;
}

export enum ConfigEnum {
  CLIENT_KUNDE = 'client.kunde',
  CLIENT_INFOBOX = 'client.infobox',
  CLIENT_MIN_LENGTH_PW = 'client.minlengthpw',
  MANDANT_SPEZI_29 = 'mandant.spezi.29',
  CUSTOM_SERVICES = 'client.besonderheiten',
  AUFTRAGSRESEARCHTABLECONFIG = 'client.auftragsresearchtableconfig',
  IS_MAUTRECHNER = 'client.mautrechner',
  IS_REGISTRIERUNG = 'client.registrierung',
  IS_TAUSCHGERAETE = 'client.tauschgeraete',
  IS_CUSTOMSTYLEBUTTONS = 'client.customstylebuttons',
  IS_DISABLE_UHRZEITFELDER = 'client.auftragserfassung.uhrzeitfelder',
  IS_LAENGE_PFLICHTFELD = 'client.auftragserfassung.laenge',
  IS_BREITE_PFLICHTFELD = 'client.auftragserfassung.breite',
  IS_HOEHE_PFLICHTFELD = 'client.auftragserfassung.hoehe',
  IS_VERKEHRSART_PFLICHTFELD = 'client.auftragserfassung.verkehrsart',
  IS_USER_CAN_EDIT_EDIT_IMMEDIATELY = 'client.benutzererfassung.editimmediately',
  IS_BEX_PREMIUM = 'client.bexpremium',
  IS_PREISERMITTLUNG = 'client.preisermittlung',
  IS_ZUSAETZLICHELADEMITTEL = 'client.zusaetzlichelademittel',
  IS_DOKUMENTENVERWEISE = 'client.dokumentenverweise',
  IS_LADEMETER_BERECHNEN = 'client.auftragserfassung.lademeterberechnen',
  IS_STELLPLAETZE_BERECHNEN = 'client.auftragserfassung.stellplaetzeberechnen',
  IS_BELADEDATUMVORBELEGEN = 'client.auftragserfassung.beladedatumvorbelegen',
  IS_ENTLADEDATUMVORBELEGEN = 'client.auftragserfassung.entladedatumvorbelegen',
  IS_SERVICES_INTERN_SENDUNGEN = 'client.auftragserfassung.services_intern_sendungen',
  IS_ADRESSE_TELEFON_EDIT = 'client.adresse.telefonedit',
  IS_ADRESSE_EINMALADRESSE_EDIT = 'client.adresse.einmaladresseedit',
  IS_ADRESSE_KONTAKT_EDIT = 'client.adresse.kontaktedit',
  IS_ADRESSE_UNSICHTBAR_EDIT = 'client.adresse.unsichtbaredit',
  TT_EMPFAENGER_FREMDNUMMER = 'client.tt.empfaenger.fremdnummer',
  TT_EMPFAENGER_MATCHCODE = 'client.tt.empfaenger.matchcode',
  TT_EMPFAENGER_STRASSE = 'client.tt.empfaenger.strasse',
  TT_INHALT = 'client.tt.inhalt',
  TT_VERSENDER_BLOCK_LABEL = 'client.tt.versender.block.label',
  TT_VERSENDER_FREMDNUMMER = 'client.tt.versender.fremdnummer',
  TT_VERSENDER_FREMDNUMMER_LABEL = 'client.tt.versender.fremdnummer.label',
  TT_VERSENDER_MATCHCODE = 'client.tt.versender.matchcode',
  TT_VERSENDER_NAME = 'client.tt.versender.name',
  TT_VERSENDER_ORT = 'client.tt.versender.ort',
  TT_VERSENDER_STRASSE = 'client.tt.versender.strasse',
  TT_IS_SHOW_TT_MAILADRESS = 'client.tt.showmailadress',
  TT_IS_SHOW_EMPF_RECHNUNG = 'client.auftragserfassung.empfaenger.rechnung',
  IS_DENY_ORDER_EDIT = 'client.auftragserfassung.denyorderedit',
  IS_SHOW_ALLGEMEIN_KLASSIFIZIERUNG = 'client.auftragserfassung.allgemein.klassifizierung', //neuer config_param
  IS_NO_ADR_VERPACKUNGEN = 'client.auftragserfassung.noadrverpackungen',
  IS_NO_ADR_LADEMITTEL = 'client.auftragserfassung.noadrlademittel',
  IS_DENY_ZUSTELLDATUM = 'client.auftrag.zustelldatumeditdeny',
  SAVE_KONTAKTDATEN = 'client.auftragserfassung.auftraege_adressen.kontaktdatensave',
  TERMINART_FIXTERMIN = 'client.auftrag.terminart.fixtermin',
  IS_ABSENDER_EDIT_DENY = 'client.auftragserfassung.absendernonedit',
  IS_SHOW_ABSENDER_NEUTRAL = 'client.auftragserfassung.showabsenderneutral',
  IS_ABHOLDATUM_PFLICHT = 'client.auftragserfassung.abholdatumpflicht',
  IS_ZUSTELLDATUM_PFLICHT = 'client.auftragserfassung.zustelldatumpflicht',
  TT_ABSENDER_SWITCH_TO_NEUTRAL = 'client.tt.absender.switchtoneutralerabsender',
  DEFAULT_WAEHRUNG = 'client.defaultwaehrung',
  DIRECTLY_BACK_2LIST = 'client.auftragserfassung.directlyback2list',
  ZUSTELLDATUM_OFFSET = 'client.auftragserfassung.zustelldatum_offset',
  IS_ZUSTELLDATUM_OFF = 'client.historie.planned_delivery_date_off',
  IS_NOT_DELETE_DOCUMENTS = 'client.deletedocumentsforbidden',
}

export const configParamsToConfigModel = (
  params: ConfigParam[]
): ConfigModel => {
  const configModel: ConfigModel = {
    loaded: true,
    isMautrechner: false,
    isRegistrierung: false,
    isDisableUhrzeitfelder: false,
    customServices: undefined,
    isTauschgeraete: false,
    auftragsresearchtableconfig: undefined,
    isCustomstylebuttons: false,
    clientKunde: '',
    isLaengePflichtfeld: false,
    isBreitePflichtfeld: false,
    isHoehePflichtfeld: false,
    isVerkehrsartPflichtfeld: false,
    isUserCanEditImmediately: false,
    isBexPremium: false,
    isPreisermittlung: false,
    isZusaetzlicheLademittel: false,
    isServicesInternSendungen: false,
    clientInfobox: undefined,
    isAdresseTelefonEdit: false,
    isAdresseEinmaladresseEdit: false,
    isAdresseKontaktEdit: false,
    isAdresseUnsichtbarEdit: false,
    mandantSpezi29: false,
    dokumentenverweise: false,
    isLademeterBerechnen: false,
    isStellplaetzeBerechnen: false,
    isBeladedatumVorbelegen: false,
    isEntladedatumVorbelegen: false,
    ttEmpfaengerFremdnummer: true,
    ttEmpfaengerMatchcode: true,
    ttEmpfaengerStrasse: true,
    ttInhalt: true,
    ttVersenderBlockLabel: undefined,
    ttVersenderFremdnummer: true,
    ttVersenderFremdnummerLabel: undefined,
    ttVersenderMatchcode: true,
    ttVersenderName: true,
    ttVersenderOrt: true,
    ttVersenderStrasse: true,
    isShowTTMailAdress: false,
    clientMinLengthPw: undefined,
    isShowEmpfRechnung: false,
    denyOrderEdit: false,
    isShowKlassifizierung: false, //neuer config_param
    isNoADRVerpackungen: false,
    isDenyZustelldatum: false,
    saveKontaktdaten: undefined,
    terminArtFixTermin: undefined,
    isAbsenderEditDeny: false,
    isShowAbsenderNeutral: false,
    isAbholDatumPflicht: false,
    isZustellDatumPflicht: false,
    isTTSwitchAbsenderToNeutral: true,
    defaultWaehrung: '2',
    directly_back_2list: false,
    zustelldatum_offset: '1',
    zustelldatum_off: false,
    isDeleteDocumentsForbidden: false,
  };
  params.forEach(c => {
    switch (c.key) {
      case ConfigEnum.IS_MAUTRECHNER: {
        if (c.value == 'true') configModel.isMautrechner = true;
        break;
      }
      case ConfigEnum.IS_REGISTRIERUNG: {
        if (c.value == 'true') configModel.isRegistrierung = true;
        break;
      }
      case ConfigEnum.CUSTOM_SERVICES: {
        configModel.customServices = c.value;
        break;
      }
      case ConfigEnum.IS_DISABLE_UHRZEITFELDER: {
        if (c.value == 'false') configModel.isDisableUhrzeitfelder = true;
        break;
      }
      case ConfigEnum.IS_TAUSCHGERAETE: {
        if (c.value == 'true') configModel.isTauschgeraete = true;
        break;
      }
      case ConfigEnum.AUFTRAGSRESEARCHTABLECONFIG: {
        configModel.auftragsresearchtableconfig = c.value;
        break;
      }
      case ConfigEnum.IS_CUSTOMSTYLEBUTTONS: {
        if (c.value == 'true') configModel.isCustomstylebuttons = true;
        break;
      }
      case ConfigEnum.CLIENT_KUNDE: {
        configModel.clientKunde = c.value;
        break;
      }
      case ConfigEnum.IS_LAENGE_PFLICHTFELD: {
        if (c.value == 'true') configModel.isLaengePflichtfeld = true;
        break;
      }
      case ConfigEnum.IS_BREITE_PFLICHTFELD: {
        if (c.value == 'true') configModel.isBreitePflichtfeld = true;
        break;
      }
      case ConfigEnum.IS_HOEHE_PFLICHTFELD: {
        if (c.value == 'true') configModel.isHoehePflichtfeld = true;
        break;
      }
      case ConfigEnum.IS_VERKEHRSART_PFLICHTFELD: {
        if (c.value == 'true') configModel.isVerkehrsartPflichtfeld = true;
        break;
      }
      case ConfigEnum.IS_USER_CAN_EDIT_EDIT_IMMEDIATELY: {
        if (c.value == 'true') configModel.isUserCanEditImmediately = true;
        break;
      }
      case ConfigEnum.IS_BEX_PREMIUM: {
        if (c.value == 'true') configModel.isBexPremium = true;
        break;
      }
      case ConfigEnum.IS_PREISERMITTLUNG: {
        if (c.value == 'true') configModel.isPreisermittlung = true;
        break;
      }
      case ConfigEnum.IS_ZUSAETZLICHELADEMITTEL: {
        if (c.value == 'true') configModel.isZusaetzlicheLademittel = true;
        break;
      }
      case ConfigEnum.MANDANT_SPEZI_29: {
        if (c.value == 'true') configModel.mandantSpezi29 = true;
        break;
      }
      case ConfigEnum.IS_SERVICES_INTERN_SENDUNGEN: {
        if (c.value == 'true') configModel.isServicesInternSendungen = true;
        break;
      }
      case ConfigEnum.CLIENT_INFOBOX: {
        configModel.clientInfobox = c.value;
        break;
      }
      case ConfigEnum.IS_ADRESSE_TELEFON_EDIT: {
        if (c.value == 'true') configModel.isAdresseTelefonEdit = true;
        break;
      }
      case ConfigEnum.IS_ADRESSE_EINMALADRESSE_EDIT: {
        if (c.value == 'true') configModel.isAdresseEinmaladresseEdit = true;
        break;
      }
      case ConfigEnum.IS_ADRESSE_KONTAKT_EDIT: {
        if (c.value == 'true') configModel.isAdresseKontaktEdit = true;
        break;
      }
      case ConfigEnum.IS_ADRESSE_UNSICHTBAR_EDIT: {
        if (c.value == 'true') configModel.isAdresseUnsichtbarEdit = true;
        break;
      }
      case ConfigEnum.IS_DOKUMENTENVERWEISE: {
        if (c.value === 'true') configModel.dokumentenverweise = true;
        break;
      }
      case ConfigEnum.IS_BELADEDATUMVORBELEGEN: {
        if (c.value == 'true') configModel.isBeladedatumVorbelegen = true;
        break;
      }
      case ConfigEnum.IS_ENTLADEDATUMVORBELEGEN: {
        if (c.value === 'true') configModel.isEntladedatumVorbelegen = true;
        break;
      }
      case ConfigEnum.IS_STELLPLAETZE_BERECHNEN: {
        if (c.value === 'true') configModel.isStellplaetzeBerechnen = true;
        break;
      }
      case ConfigEnum.IS_LADEMETER_BERECHNEN: {
        if (c.value === 'true') configModel.isLademeterBerechnen = true;
        break;
      }
      case ConfigEnum.TT_INHALT: {
        if (c.value == 'false') {
          configModel.ttInhalt = false;
        }
        break;
      }
      case ConfigEnum.TT_EMPFAENGER_STRASSE: {
        if (c.value == 'false') {
          configModel.ttEmpfaengerStrasse = false;
        }
        break;
      }
      case ConfigEnum.TT_EMPFAENGER_MATCHCODE: {
        if (c.value == 'false') {
          configModel.ttEmpfaengerMatchcode = false;
        }
        break;
      }
      case ConfigEnum.TT_EMPFAENGER_FREMDNUMMER: {
        if (c.value == 'false') {
          configModel.ttEmpfaengerFremdnummer = false;
        }
        break;
      }
      case ConfigEnum.TT_VERSENDER_ORT: {
        if (c.value == 'false') {
          configModel.ttVersenderOrt = false;
        }
        break;
      }
      case ConfigEnum.TT_VERSENDER_FREMDNUMMER_LABEL: {
        configModel.ttVersenderFremdnummerLabel =
          c.value == null ? '' : c.value;
        break;
      }
      case ConfigEnum.TT_VERSENDER_STRASSE: {
        if (c.value == 'false') {
          configModel.ttVersenderStrasse = false;
        }
        break;
      }
      case ConfigEnum.TT_VERSENDER_NAME: {
        if (c.value == 'false') {
          configModel.ttVersenderName = false;
        }
        break;
      }
      case ConfigEnum.TT_VERSENDER_MATCHCODE: {
        if (c.value == 'false') {
          configModel.ttVersenderMatchcode = false;
        }
        break;
      }
      case ConfigEnum.TT_VERSENDER_FREMDNUMMER: {
        if (c.value == 'false') {
          configModel.ttVersenderFremdnummer = false;
        }
        break;
      }
      case ConfigEnum.TT_ABSENDER_SWITCH_TO_NEUTRAL: {
        if (c.value == 'false') {
          configModel.isTTSwitchAbsenderToNeutral = false;
        }
        break;
      }
      case ConfigEnum.TT_IS_SHOW_TT_MAILADRESS: {
        if (c.value == 'true') {
          configModel.isShowTTMailAdress = true;
        }
        break;
      }
      case ConfigEnum.TT_VERSENDER_BLOCK_LABEL: {
        configModel.ttVersenderBlockLabel = c.value ?? '';
        break;
      }
      case ConfigEnum.CLIENT_MIN_LENGTH_PW: {
        configModel.clientMinLengthPw = c.value ?? '';
        break;
      }
      case ConfigEnum.TT_IS_SHOW_EMPF_RECHNUNG: {
        if (c.value == 'true') {
          configModel.isShowEmpfRechnung = true;
        }
        break;
      }

      case ConfigEnum.IS_SHOW_ALLGEMEIN_KLASSIFIZIERUNG: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.isShowKlassifizierung = true;
        }
        break;
      }

      case ConfigEnum.IS_DENY_ORDER_EDIT: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.denyOrderEdit = true;
        }
        break;
      }
      case ConfigEnum.IS_NO_ADR_VERPACKUNGEN: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.isNoADRVerpackungen = true;
        }
        break;
      }
      case ConfigEnum.IS_NO_ADR_LADEMITTEL: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.isNoADRLademittel = true;
        }
        break;
      }
      case ConfigEnum.IS_DENY_ZUSTELLDATUM: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.isDenyZustelldatum = true;
        }
        break;
      }
      case ConfigEnum.TERMINART_FIXTERMIN: {
        configModel.terminArtFixTermin = c.value;
        break;
      }
      case ConfigEnum.SAVE_KONTAKTDATEN: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.saveKontaktdaten = true;
        }
        break;
      }
      case ConfigEnum.IS_ABSENDER_EDIT_DENY: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.isAbsenderEditDeny = true;
        }
        break;
      }

      case ConfigEnum.IS_SHOW_ABSENDER_NEUTRAL: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.isShowAbsenderNeutral = true;
        }
        break;
      }

      case ConfigEnum.IS_ABHOLDATUM_PFLICHT: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.isAbholDatumPflicht = true;
        }
        break;
      }

      case ConfigEnum.IS_ZUSTELLDATUM_PFLICHT: {
        //neuer config_param
        if (c.value == 'true') {
          configModel.isZustellDatumPflicht = true;
        }
        break;
      }
      case ConfigEnum.DIRECTLY_BACK_2LIST: {
        if (c.value == 'true') {
          configModel.directly_back_2list = true;
        }
        break;
      }

      case ConfigEnum.DEFAULT_WAEHRUNG: {
        if (c.value) configModel.defaultWaehrung = c.value;
        break;
      }

      case ConfigEnum.ZUSTELLDATUM_OFFSET: {
        if (c.value) configModel.zustelldatum_offset = c.value;
        break;
      }
      case ConfigEnum.IS_ZUSTELLDATUM_OFF: {
        if (c.value == 'true') configModel.zustelldatum_off = true;
        break;
      }
      case ConfigEnum.IS_NOT_DELETE_DOCUMENTS: {
        if (c.value == 'true') configModel.isDeleteDocumentsForbidden = true;
        break;
      }
    }
  });

  return { ...configModel };
};
